import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleClick = () => this.toggleVisibility()

    const existingWrapper = this.element.parentNode
    if (existingWrapper?.classList.contains("password-toggle")) {
      this.wrapper = existingWrapper
      this.toggle = existingWrapper.querySelector(".password-toggle__button")
      this.visible = this.element.type === "text"
      if (this.toggle) {
        this.toggle.textContent = this.visible ? "Hide" : "Show"
        this.toggle.addEventListener("click", this.handleClick)
      }
      return
    }

    this.visible = false
    this.wrapInput()
    this.createToggle()
  }

  disconnect() {
    if (this.toggle && this.handleClick) {
      this.toggle.removeEventListener("click", this.handleClick)
    }
  }

  wrapInput() {
    this.wrapper = document.createElement("div")
    this.wrapper.classList.add("password-toggle")
    this.element.parentNode.insertBefore(this.wrapper, this.element)
    this.wrapper.appendChild(this.element)
  }

  createToggle() {
    this.toggle = document.createElement("button")
    this.toggle.type = "button"
    this.toggle.classList.add("password-toggle__button")
    this.toggle.setAttribute("aria-label", "Toggle password visibility")
    this.toggle.textContent = "Show"
    this.toggle.addEventListener("click", this.handleClick)
    this.wrapper.appendChild(this.toggle)
  }

  toggleVisibility() {
    this.visible = !this.visible
    this.element.type = this.visible ? "text" : "password"
    this.toggle.textContent = this.visible ? "Hide" : "Show"
  }
}
